import React, { useEffect } from "react";
import Navbar from "../components/layout/navbar";
import Footer from "../components/layout/footer";
import AboutBanner from "../components/pages/Aboutus/aboutBanner";
import Abouthero from "../components/pages/Aboutus/Abouthero";
import Testimonials from "../components/pages/Aboutus/testimonials";
import Ourmission from "../components/pages/Aboutus/ourmission";
import About from "../components/pages/Aboutus/about";
import MakesusDiff from "../components/pages/Aboutus/makesusDiff";

const Aboutus = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <AboutBanner />
      <Abouthero />
      <Ourmission />
      <MakesusDiff />
      {/* <About />
      <Testimonials /> */}
      <Footer />
    </>
  );
};

export default Aboutus;
